<template>
  <div>
    <!-- <section class="d-flex body-content" style="background-color: #f1f3f4">
      <h1>Lobby Template 1</h1>
    </section> -->
    <div class="page-effect">
      <div class="container-fluid border-bottom p-0 ss-reg-top pt-3">
        <div
          class="
            admin-edit-lobby-head-area
            d-flex
            justify-content-between
            align-items-center
            pl-2
          "
        >
          <h3>Lobby Template 5</h3>
          <div class="d-md-flex justify-content-end page-option-sticky">
            <a
              href="#"
              class="pt-3"
              data-toggle="modal"
              data-target="#welcomemailModalCenter"
              @click="
                $refs.reminderAnnounceMailPopup.getMailTemplate('ReminderMail')
              "
            >
              <v-icon color="#1c1d26" size="25px">mdi-arrow-right-top</v-icon>
              Send Mail</a
            >

            <a
              href="#"
              class="pt-3"
              data-toggle="modal"
              data-target="#RegistrationtypeModal"
              @click="openLobbySettingsDialog()"
              ><v-icon color="#1c1d26" size="25px">mdi-cog-outline</v-icon>
              Lobby Settings</a
            >

            <a
              href="#"
              class="pt-3"
              data-toggle="modal"
              data-target="#CheckoutformypeModal"
              ><v-icon color="#1c1d26" size="25px">mdi-tray-arrow-up</v-icon>
              Bulk Import</a
            >
          </div>
        </div>
      </div>
      <div class="d-flex body-content py-0">
        <div class="lobby-wrap position-relative">
          <img src="../assets/Images/lobby-templates/lobby5.jpg" />
          <div class="blink_ffect_wrapper edit-wrap27">
            <a
              class="circle_blink_button"
              data-openeditor="left-banner"
              @click.stop="drawer = !drawer"
            >
              <span>&nbsp;</span>
            </a>
          </div>
          <div class="blink_ffect_wrapper edit-wrap25">
            <a
              class="circle_blink_button"
              data-openeditor="left-banner"
              @click.stop="drawer = !drawer"
            >
              <span>&nbsp;</span>
            </a>
          </div>
          <div class="blink_ffect_wrapper edit-wrap28">
            <a
              class="circle_blink_button"
              data-openeditor="left-banner"
              @click.stop="drawer = !drawer"
            >
              <span>&nbsp;</span>
            </a>
          </div>
          <div class="blink_ffect_wrapper edit-wrap29">
            <a
              class="circle_blink_button"
              data-openeditor="left-banner"
              @click.stop="drawer = !drawer"
            >
              <span>&nbsp;</span>
            </a>
          </div>
          <div class="blink_ffect_wrapper edit-wrap24">
            <a
              class="circle_blink_button"
              data-openeditor="left-banner"
              @click.stop="drawer = !drawer"
            >
              <span>&nbsp;</span>
            </a>
          </div>
          <div class="blink_ffect_wrapper edit-wrap26">
            <a
              class="circle_blink_button"
              data-openeditor="left-banner"
              @click.stop="drawer = !drawer"
            >
              <span>&nbsp;</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <v-navigation-drawer
      v-model="drawer"
      top
      fixed
      width="400"
      floating="true"
      class="p-3"
      temporary
      hide-overlay="true"
    >
      <div class="editor-drawer-head">
        <h4 class="mb-0 d-flex justify-content-start align-items-ceter">
          <v-icon color="#1c1d26" size="25px">mdi-chevron-left</v-icon> Editor
        </h4>
      </div>
      <div class="hotspots-wrapper mt-3">
        <div class="single-edit-hotspot my-3">
          <h5>Video Banner</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <p class="my-2 text-center"><b>Or</b></p>

          <div class="lobby-upload-banner-image">
            <label>Upload Video</label>
            <div
              class="
                d-flex
                justify-content-between
                align-items-center
                final-button
                mb-4
              "
            >
              <input type="file" name="" id="" value="" />
              <v-btn dark color="#1c1d26">Upload</v-btn>
            </div>
            <div class="lobby-banner-image mb-5">
              <div class="image-holder">
                <img src="../assets/Images/reg-ico/video-file.svg" />
              </div>
              <v-btn icon
                ><v-icon color="#1c1d26" size="25px"
                  >mdi-trash-can-outline</v-icon
                ></v-btn
              >
            </div>
          </div>
          <div
            class="d-flex justify-content-end align-items-center final-button"
          >
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2"
              >Cancel</v-btn
            >
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>

        <div class="single-edit-hotspot my-3">
          <h5>Agenda</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div
            class="d-flex justify-content-end align-items-center final-button"
          >
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2"
              >Cancel</v-btn
            >
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>

        <div class="single-edit-hotspot my-3">
          <h5>Exhibitors</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div
            class="d-flex justify-content-end align-items-center final-button"
          >
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2"
              >Cancel</v-btn
            >
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>

        <div class="single-edit-hotspot my-3">
          <h5>Round Table</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div
            class="d-flex justify-content-end align-items-center final-button"
          >
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2"
              >Cancel</v-btn
            >
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>

        <div class="single-edit-hotspot my-3">
          <h5>One to One Meeting</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div
            class="d-flex justify-content-end align-items-center final-button"
          >
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2"
              >Cancel</v-btn
            >
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>
        <div class="single-edit-hotspot my-3">
          <h5>Information</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div
            class="d-flex justify-content-end align-items-center final-button"
          >
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2"
              >Cancel</v-btn
            >
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>

        <!-- <div class="single-edit-hotspot my-3">
          <h5>Exhibitors</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div class="d-flex justify-content-end align-items-center final-button">
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2">Cancel</v-btn>
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>

        <div class="single-edit-hotspot my-3">
          <h5>Help Desc</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div class="d-flex justify-content-end align-items-center final-button">
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2">Cancel</v-btn>
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div> -->
      </div>
    </v-navigation-drawer>
    <div>
      <v-row justify="center">
        <v-dialog v-model="lobbySettingsDialog" max-width="1000px">
          <v-card class="attendee-add-wrap-mod">
            <div style="position: absolute; right: 10px; top: 15px">
              <v-icon
                style="z-index: 2"
                size="32"
                @click="lobbySettingsDialog = false"
                >close</v-icon
              >
            </div>
            <v-card-title>
              <h5>Edit Lobby</h5>
            </v-card-title>

            <v-card-text>
              <div class="imageEdit-lobby-hotspot-area">
                <div
                  class="
                    hotspotEdit-upload-area
                    final-button
                    d-flex
                    justify-content-between
                    align-items-end
                  "
                >
                  <div>
                    <label>Upload Hotspot Image</label>
                    <div
                      class="d-flex justify-content-start align-items-center"
                    >
                      <input type="text" name="" id="" value="" />
                      <button type="file" value="" class="upload-img">
                        Upload
                      </button>
                      <!-- <button
                        value=""
                        class="upload-reset"
                        @click="openConfirmDialog()"
                      >
                        Reset Default
                      </button> -->
                      <button
                        value=""
                        class="upload-reset"
                        @click="snackbar = true"
                      >
                        Reset Default
                      </button>
                    </div>
                  </div>
                  <v-btn color="#1c1d26" outlined width="180px" large>
                    <img
                      class="mr-2"
                      src="../assets/Images/psd-ico.png"
                    />Download PSD</v-btn
                  >
                </div>
                <div class="mt-8 imageEditt-lobby-hotspot-image">
                  <img src="../assets/Images/image-hotspot-wrap.jpg" />
                </div>
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <div
                class="
                  d-flex
                  justify-content-end
                  align-items-center
                  final-button
                  pb-3
                "
              >
                <v-btn
                  outlined
                  large
                  color="#1c1d26"
                  class="mr-2"
                  @click="lobbySettingsDialog = false"
                  width="120px"
                  >Cancel</v-btn
                >
                <v-btn
                  dark
                  large
                  color="#1c1d26"
                  class="mr-2"
                  @click="lobbySettingsDialog = false"
                  width="120px"
                  >Save</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>



        <!-- <v-dialog v-model="lobbyConfirmDialog" max-width="500px" hide-overlay>
          <v-card>
            <v-card-title>
             <div class="restore-default-head d-flex justify-content-end align-items-start">
               
               <v-btn text fab color="#1c1d26" height="30px" width="30px" @click="lobbyConfirmDialog = false"><v-icon color="#1c1d26" size="25px">mdi-close</v-icon></v-btn>
             </div>
             <div class="confirmation-option-button  pb-10 final-button  d-flex justify-content-center align-items-center flex-column">
               <h5>Are you confirm to reset default?</h5>
               <div class="mt-5">
                <v-btn dark large color="#1c1d26" width="120px" class="mr-2" @click="lobbyConfirmDialog = false">Yes</v-btn>
                <v-btn large color="#1c1d26" outlined width="120px" @click="lobbyConfirmDialog = false">No</v-btn>
               </div>
             </div>
            </v-card-title>
          </v-card>
        </v-dialog> -->
        <v-snackbar text v-model="snackbar" timeout="-1" top color="primary">
          <div class="restore-default-head d-flex justify-content-between align-items-center">
            <div class="d-flex justify-content-start align-items-center mr-5">
              
                
              <h5>Are you sure you want to reset lobby theme? </h5>
            </div>
            <div class="final-button d-flex justify-content-end align-items-center">
             <v-btn dark small class="mr-1 confirm-roger" color="#1c1d26"  v-bind="attrs" @click="snackbar = false">
              Yes
            </v-btn>
            <v-btn color="#1c1d26" outlined small v-bind="attrs" @click="snackbar = false">
              No
            </v-btn>
            </div>
          </div>          
        </v-snackbar>
      </v-row>
    </div>
  </div>
</template>
<script>
// import db from "../components/firebaseInit";
// import APIs from "@/components/APIInit";
// import router from "../router";
// import jQuery from "jquery";
// let $ = jQuery;
// var self;
// import Vue from "vue";
// import VueMoment from "vue-moment";
// import moment from "moment-timezone";
// import axios from "axios";
// import { bus } from "@/main";
// Vue.use(VueMoment, {
//   moment,
// });

export default {
  data() {
    return {
      drawer: false,
      group: null,
      dialog: false,
      lobbySettingsDialog: false,
      lobbyConfirmDialog: false,
      snackbar: false,
    };
  },
  computed: {},
  watch: {
    group() {
      this.drawer = false;
    },
  },
  created() {},
  mounted() {},
  methods: {
    openLobbySettingsDialog() {
      this.lobbySettingsDialog = true;
    },
    openConfirmDialog() {
      this.lobbyConfirmDialog = true;
    },
  },
};
</script>